module.exports = __webpack_public_path__ + "static/media/bg-section-03.2d5dd426.png";